import { useState } from 'react';

interface Toggle {
  id: string;
  label: string;
  desc: string;
  defaultOn: boolean;
  icon: string;
  danger?: boolean;
}

const toggles: Toggle[] = [
  { id: 'show_country', icon: 'ri-map-pin-line', label: 'Ülkemi Göster', desc: 'Sohbet ekranında ülke bilgini diğer kullanıcılara göster.', defaultOn: true },
  { id: 'show_online', icon: 'ri-wifi-line', label: 'Çevrimiçi Durumumu Göster', desc: 'Platformda aktif olduğunda diğerlerine görünür ol.', defaultOn: true },
  { id: 'anonymous_mode', icon: 'ri-ghost-line', label: 'Anonim Mod', desc: 'Profil bilgilerini gizle, tamamen anonim eşleş.', defaultOn: false },
  { id: 'save_history', icon: 'ri-history-line', label: 'Sohbet Geçmişini Sakla', desc: 'Geçmiş sohbetlerin yerel olarak kaydedilsin.', defaultOn: false },
  { id: 'data_analytics', icon: 'ri-bar-chart-line', label: 'Analitik Verilerine İzin Ver', desc: 'Deneyimi geliştirmemize yardımcı olmak için anonim kullanım verisi paylaş.', defaultOn: true },
];

const dangerActions = [
  { icon: 'ri-delete-bin-line', label: 'Sohbet Geçmişini Temizle', desc: 'Tüm geçmiş sohbet verilerini kalıcı olarak sil.' },
  { icon: 'ri-user-unfollow-line', label: 'Engellenen Kullanıcıları Yönet', desc: 'Engellediğin kullanıcıları görüntüle veya engeli kaldır.' },
];

const PrivacySection = () => {
  const [states, setStates] = useState<Record<string, boolean>>(
    Object.fromEntries(toggles.map((t) => [t.id, t.defaultOn]))
  );
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleToggle = (id: string) => {
    setStates((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleSave = () => {
    setSaving(true);
    setTimeout(() => { setSaving(false); setSaved(true); setTimeout(() => setSaved(false), 2500); }, 900);
  };

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl font-extrabold text-white mb-1">Gizlilik & Güvenlik</h2>
        <p className="text-white/40 text-sm">Kişisel verilerini ve gizlilik tercihlerini yönet.</p>
      </div>

      <div className="flex flex-col gap-4 mb-6">
        {toggles.map((t) => (
          <div
            key={t.id}
            className="flex items-center justify-between gap-4 p-5 rounded-2xl bg-white/3 border border-white/8"
          >
            <div className="flex items-start gap-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/6 text-white/40 flex-shrink-0 mt-0.5">
                <i className={`${t.icon} text-base`} />
              </div>
              <div>
                <p className="text-white/80 text-sm font-semibold">{t.label}</p>
                <p className="text-white/35 text-xs mt-0.5 leading-relaxed">{t.desc}</p>
              </div>
            </div>
            {/* Toggle switch */}
            <button
              onClick={() => handleToggle(t.id)}
              className={`relative w-12 h-6 rounded-full flex-shrink-0 transition-all duration-300 cursor-pointer ${
                states[t.id] ? 'bg-cyan-500' : 'bg-white/10'
              }`}
            >
              <div
                className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow-sm transition-all duration-300 ${
                  states[t.id] ? 'left-7' : 'left-1'
                }`}
              />
            </button>
          </div>
        ))}
      </div>

      {/* Danger zone */}
      <div className="p-6 rounded-2xl bg-red-500/4 border border-red-500/15 mb-6">
        <h3 className="text-red-400 font-bold text-sm mb-4 flex items-center gap-2">
          <i className="ri-alert-line" /> Tehlikeli Bölge
        </h3>
        <div className="flex flex-col gap-3">
          {dangerActions.map((action) => (
            <div key={action.label} className="flex items-center justify-between gap-4 p-4 rounded-xl bg-white/2 border border-white/6">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-500/10 text-red-400">
                  <i className={`${action.icon} text-sm`} />
                </div>
                <div>
                  <p className="text-white/70 text-sm font-semibold">{action.label}</p>
                  <p className="text-white/30 text-xs">{action.desc}</p>
                </div>
              </div>
              <button className="px-4 py-2 rounded-xl bg-red-500/12 border border-red-500/20 text-red-400 text-xs font-semibold hover:bg-red-500/20 transition-all cursor-pointer whitespace-nowrap">
                Yönet
              </button>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        className="px-8 py-3.5 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white font-bold text-sm hover:from-cyan-400 hover:to-violet-500 transition-all cursor-pointer disabled:opacity-60 whitespace-nowrap shadow-lg shadow-cyan-500/20"
      >
        {saving ? (
          <span className="flex items-center gap-2"><i className="ri-loader-4-line animate-spin" /> Kaydediliyor...</span>
        ) : saved ? (
          <span className="flex items-center gap-2 text-emerald-300"><i className="ri-checkbox-circle-line" /> Kaydedildi!</span>
        ) : (
          <span className="flex items-center gap-2"><i className="ri-save-line" /> Kaydet</span>
        )}
      </button>
    </div>
  );
};

export default PrivacySection;
